import { render, staticRenderFns } from "./_ComboBox.vue?vue&type=template&id=2b383083"
import script from "./_ComboBox.vue?vue&type=script&lang=ts"
export * from "./_ComboBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports